import { render, staticRenderFns } from "./PostWithExcerpt.vue?vue&type=template&id=b24fe152&"
import script from "./PostWithExcerpt.vue?vue&type=script&lang=ts&"
export * from "./PostWithExcerpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports